<template>
  <div class="rightBottom">
    <div class="tabulation" v-if="titleName=='主要流通股东'">
      <!-- 表格纵列 -->
      <div class="tabulationTop">
        <div class="tabulationTopTitle">
          <table>
            <tr>
              <th>截止日期</th>
            </tr>
            <tr>
              <th>公告日期</th>
            </tr>
          </table>
        </div>
        <div class="con">
          <table>
            <!-- 截止日期 -->
            <tr>
              <td>{{closeDate}}</td>
            </tr>
            <!-- 公告日期 -->
            <tr>
              <td>{{anDate}}</td>
            </tr>
          </table>
        </div>
      </div>
      <!-- 下部横向 -->
      <div class="tabulationBottom">
        <el-table :data="circulateList" style="width: 100%" border size="mini">
          <el-table-column label="序号" width="140">
            <template slot-scope="scope">{{scope.$index+1}}</template>
          </el-table-column>
          <af-table-column prop="shareholderName" label="股东名称"></af-table-column>
          <af-table-column prop="shareholdersNumber" label="本期持有股(股)"></af-table-column>
          <af-table-column prop="shareholdingRatio" label="持有比例(%)"></af-table-column>
          <af-table-column prop="capitalStockNature" label="股份类型"></af-table-column>
        </el-table>
      </div>
    </div>
    <div class="tabulation" v-if="titleName=='主要股东'">
      <!-- 表格纵列 -->
      <div class="tabulationTop">
        <div class="tabulationTopTitle">
          <table>
            <tr>
              <th>截止日期</th>
            </tr>
            <tr>
              <th>公告日期</th>
            </tr>
            <tr>
              <th class="custom">股东总数</th>
            </tr>
            <tr>
              <th class="custom" border="none">平均持股数(股)</th>
            </tr>
          </table>
        </div>
        <div class="con">
          <table>
            <!-- 截止日期 -->
            <tr>
              <td>{{closeDate.substr(0,10)}}</td>
            </tr>
            <!-- 公告日期 -->
            <tr>
              <td>{{anDate.substr(0,10)}}</td>
            </tr>
            <!-- 股东总数 -->
            <tr>
              <td>
                {{totalNum}}
                <!-- <span class="trends" @click="lookTrends()">查看变化趋势</span> -->
              </td>
            </tr>
            <!-- 平均持股数 -->
            <tr>
              <td>
                {{averageNum}}
                <!-- <span class="trends" @click="lookBalance()">查看变化趋势</span> -->
              </td>
              <!-- <td>{{majorList[0].averageNum}}</td>   -->
            </tr>
          </table>
        </div>
      </div>
      <!-- 下部横向 -->
      <div class="tabulationBottom">
        <el-table :data="circulateList" style="width: 100%" border size="mini">
          <el-table-column label="序号">
            <template slot-scope="scope">{{scope.$index+1}}</template>
          </el-table-column>
          <af-table-column prop="shareholderName" label="股东名称"></af-table-column>
          <af-table-column prop="capitalStockNature" label="股本性质"></af-table-column>
          <af-table-column prop="shareholdersNumber" label="持股数量(股)"></af-table-column>
          <af-table-column prop="shareholdingRatio" label="持有比例(%)"></af-table-column>
        </el-table>
      </div>
    </div>
    <Shade v-show="shade"></Shade>
    <Balance v-show="balance"></Balance>
  </div>
</template>

<script>
import Shade from "@/components/shade";
import Balance from "@/components/balance";
export default {
  props: ["data1", "data2", "titleName"],
  components: {
    Shade,
    Balance
  },
  data() {
    return {
      shade: false, //遮罩
      balance: false, //遮罩
      selectDate: {
        value: "",
        deadline: []
      },

      stockCode: "",
      enterpriseCode: "",

      closeDate: "",
      anDate: "",

      liquidityShareholdersCode: "",
      shareholderName: "",
      shareholdersNumber: "",
      shareholdingRatio: "",
      capitalStockNature: "",
      totalNum: "",
      averageNum: "",
      circulateList: []
    };
  },
  mounted() {
    // console.log(this.data1, this.data2, this.titleName);
    this.closeDate = this.data1.rows.closeDate;
    this.anDate = this.data1.rows.anDate;
    this.totalNum = this.data1.rows.totalNum;
    this.averageNum = this.data1.rows.averageNum;
    this.circulateList = this.data2.rows;
  },
  methods: {
    lookTrends() {
      this.shade = !this.shade;
    },
    lookBalance() {
      this.balance = !this.balance;
    },
    cellStyle(row, column, rowIndex, columnIndex) {
      if (row.columnIndex == 0 || row.rowIndex == 0) {
        return "color: #DFECF7;font-weight:bold;font-family:Microsoft YaHei;background:rgba(5, 43, 79, 0.8) !important;";
      }
    }
  }
};
</script>

<style scoped lang='less'>
.rightBottom {
  width: 100%;
  .tabulationBottom {
    width: 100%;
  }
}
.tabulation {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  .tabulationTop {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
    .tabulationTopTitle {
      width: 140px;
      table th {
        width: 140px;
        height: 35px;
        line-height: 35px;
        padding-left: 11px;
        vertical-align: middle;
        background-color: #375572;
        border: 1px solid #08396a;
        border-right: 0px solid #08396a;
        font-size: 14px;
        color: #fff;
        font-weight: bold;
      }
    }
    .con {
      flex: 1;
      table {
        width: 100%;
      }
      table td {
        height: 35px;
        line-height: 35px;
        border: 1px solid #08396a;
        padding-left: 11px;
        color: #fff;
        // text-align: center;
        vertical-align: middle;
        .trends {
          color: #3583ed;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          margin-left: 19px;
          display: inline-block;
          cursor: pointer;
          height: 100%;
        }
      }
    }
  }
}
/deep/ .el-table--border td,
.el-table--border th {
  background: rgba(5, 43, 79, 1);

  border: 1px solid #08396a !important;
}
/deep/ .el-table::before,
/deep/ .el-table--border::after {
  background: none;
}
/deep/ .el-table--border th,
.el-table--border th.gutter:last-of-type {
  background: rgba(5, 43, 79, 0.8) !important;
  border: 1px solid #08396a !important;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #dfecf7;
}
/deep/ tbody tr {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #dfecf7;
}
/deep/ .el-table--border,
/deep/.el-table--group {
  border: 0;
}
/deep/ .el-table__fixed::before {
  background: none;
}
/deep/ .el-table__row {
  pointer-events: none;
}
/deep/.el-table--enable-row-hover .el-table__body tr > td {
  pointer-events: none;
  //   background-color: #F5F7FA;
  //   color:#000;
}
/deep/ .el-table__empty-block {
  width: 100% !important;
  background: #052b4f;
}
/deep/ .el-table__body-wrapper {
  background: #052b4f !important;
}
</style>


// WEBPACK FOOTER //
// src/components/table4.vue